import { render } from "./One8.vue?vue&type=template&id=030e2c7c&scoped=true&lang=pug"
import script from "./One8.vue?vue&type=script&lang=js"
export * from "./One8.vue?vue&type=script&lang=js"

import "./One8.vue?vue&type=style&index=0&id=030e2c7c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\freemath\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-030e2c7c"]])

export default __exports__